import { leadStatusConstant } from "../constants/leadStatusConstant";
import type { LeadStatus } from "../../services/leadStatusService";

interface LeadStatusState {
  statuses: LeadStatus[];
  loading: boolean;
  error: any | null;
}

interface LeadStatusAction {
  type: string;
  data?: any;
  error?: any;
}

const initialState: LeadStatusState = {
  statuses: [],
  loading: false,
  error: null,
};

export default function leadStatus(
  state = initialState,
  action: LeadStatusAction
): LeadStatusState {
  switch (action.type) {
    // Get lead statuses
    case leadStatusConstant.GET_LEAD_STATUSES_R:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case leadStatusConstant.GET_LEAD_STATUSES_S:
      return {
        ...state,
        statuses: action.data?.data?.statuses || [],
        loading: false,
      };

    case leadStatusConstant.GET_LEAD_STATUSES_F:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Create lead status
    case leadStatusConstant.CREATE_LEAD_STATUS_R:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case leadStatusConstant.CREATE_LEAD_STATUS_S: {
      const newStatus = action.data?.data?.status;
      if (newStatus) {
        return {
          ...state,
          statuses: [...state.statuses, newStatus],
          loading: false,
        };
      }
      return {
        ...state,
        loading: false,
      };
    }

    case leadStatusConstant.CREATE_LEAD_STATUS_F:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Update lead status
    case leadStatusConstant.UPDATE_LEAD_STATUS_R:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case leadStatusConstant.UPDATE_LEAD_STATUS_S: {
      const updatedStatus = action.data?.data?.status;
      if (updatedStatus) {
        return {
          ...state,
          statuses: state.statuses.map((status) =>
            status.id === updatedStatus.id ? updatedStatus : status
          ),
          loading: false,
        };
      }
      return {
        ...state,
        loading: false,
      };
    }

    case leadStatusConstant.UPDATE_LEAD_STATUS_F:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Delete lead status
    case leadStatusConstant.DELETE_LEAD_STATUS_R:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case leadStatusConstant.DELETE_LEAD_STATUS_S: {
      const statusName = action.data?.statusName;
      if (statusName) {
        return {
          ...state,
          statuses: state.statuses.filter(
            (status) => status.name !== statusName
          ),
          loading: false,
        };
      }
      return {
        ...state,
        loading: false,
      };
    }

    case leadStatusConstant.DELETE_LEAD_STATUS_F:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}

